import { Observable } from '@logz-pkg/observable';

class LuceneInputStateService {
  state = new Observable<string>('');
  setState = (text: string) => {
    this.state.set(text);
  };

  clear = () => {
    this.state.set('');
  };
}

export const luceneInputStateService = new LuceneInputStateService();
